export const STANDARD_MODEL_TYPES = [
  "hydrologic/ hydraulic 1d",
  "hydraulic 1d/2d",
  "hydraulic 2d",
  "Other",
];

export const OTHER_MODEL_TYPE_LABEL = "Other";
const OTHER_MODEL_TYPE_PREFIX = "Other: ";

/** Keep a custom model type inside the modelType value the API already stores. */
export const encodeModelTypeForStorage = (modelType, otherModelType) => {
  const custom =
    typeof otherModelType === "string" ? otherModelType.trim() : "";
  if (modelType === OTHER_MODEL_TYPE_LABEL && custom) {
    return `${OTHER_MODEL_TYPE_PREFIX}${custom}`;
  }
  return modelType;
};

const toText = (value) => {
  if (Array.isArray(value)) {
    return value.filter((item) => item != null && item !== "").join(", ");
  }
  return value;
};

/** Restore the Other dropdown and its text box from a stored model type. */
export const decodeStoredModelType = (modelType, otherModelType) => {
  const storedModelType = toText(modelType);
  const customValue = toText(otherModelType);
  const custom = typeof customValue === "string" ? customValue.trim() : "";
  if (
    typeof storedModelType === "string" &&
    storedModelType.startsWith(OTHER_MODEL_TYPE_PREFIX)
  ) {
    return {
      modelType: OTHER_MODEL_TYPE_LABEL,
      otherModelType: storedModelType.slice(OTHER_MODEL_TYPE_PREFIX.length),
    };
  }
  if (
    storedModelType &&
    storedModelType !== OTHER_MODEL_TYPE_LABEL &&
    !STANDARD_MODEL_TYPES.includes(storedModelType) &&
    !custom
  ) {
    return {
      modelType: OTHER_MODEL_TYPE_LABEL,
      otherModelType: String(storedModelType),
    };
  }
  return {
    modelType: storedModelType ?? "",
    otherModelType: custom,
  };
};
